import { Injectable } from '@angular/core';


@Injectable()
export class LoggerService {

  constructor() { }

  public log(msg?: any, ...objects: any[]){
      console.log.apply( console, arguments );
  }

  public error(msg?: any, ...objects: any[]){
      console.error.apply( console, arguments );
  }

  public warning(msg?: any, ...objects: any[]){
      console.warn.apply( console, arguments );
  }

  public info(msg?: any, ...objects: any[]){
      console.info.apply( console, arguments );
  }

  public debug(msg?: any, ...objects: any[]){
      console.debug.apply( console, arguments );
  }

}
